import React from "react";
import { SearchGroupList } from "../../../../model/branch/BranchGroupsModel";
import { ResponsiveDeviceType } from "../../../../widget/layouts/ScreenMedia";
import Loader from "../../../../widget/common/ui/Loader";
import Center from "../../../../widget/common/ui/Center";
import { Listing, ListItem } from "../../../../widget/common/ui/Listing";
import Div from "../../../../widget/common/ui/Div";
import { TextBlock } from "../../../../widget/common/ui/Text";
import NoData from "../../../../widget/common/ui/NoData";

const BranchGroupsList = (props: {
  groupList: Array<SearchGroupList> | null;
  type?: number | undefined;
  onClickGroup: (detail: SearchGroupList) => void;
}) => {
  const type: number = props.type ?? ResponsiveDeviceType();

  return (
    <>
      {props.groupList == null ? (
        <Center>{Loader.normal()}</Center>
      ) : props.groupList.length === 0 ? (
        <Center>
          <NoData />
        </Center>
      ) : (
        <Listing>
          {(props.groupList ?? []).map((group, key) => (
            <ListItem key={key}>
              <div
                role="button"
                className={type === 1 ? `py-1` : `py-2`}
                onClick={() => props.onClickGroup(group)}
              >
                <Div fontName="book" color="theme-label" fontSize="16_17">
                  <TextBlock>{group.group_title}</TextBlock>
                </Div>
              </div>
            </ListItem>
          ))}
        </Listing>
      )}
    </>
  );
};

export default BranchGroupsList;
